import { useQuery } from '@tanstack/react-query';
import { getPartyStages } from 'services/api/getPartyStages';
import { queryKeys } from '../queryKeys';

export const useGetPartyStages = (isEnabled = true) => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.partyStages,
        queryFn: getPartyStages,
        enabled: isEnabled,
        staleTime: Infinity,
    });

    return { partyStages: data, isPartyStagesLoading: isLoading, ...rest };
};
